import { renderTFButton } from './adapter.northstar';
/**
 * The app's single button primitive.
 *
 * Thin shell: imports no vendor package. At design system migration, the
 * ONLY THING THAT CHANGES is the import line below (`./adapter.v9` etc.).
 * Keeping two adapters at once behind a flag also allows a gradual rollout.
 */ var TFButton = function TFButton(props) {
    return renderTFButton(props);
};
export default TFButton;
